import { http } from '@/core/api/';

const apiUrl = 'api/metapr';

export const getAcademicYears = () => {
  return http.get('api/academicyears/getacademicyearstocurrentyear');
};

export const getSchoolGrades = () => {
  return http.get('api/code/schoolgradesformetapr');
};

export const getMetaPrData = (academicYear) => {
  return http.get(`${apiUrl}/metaprtable/${academicYear}`);
};

export const getConfMetaPrData = (academicYear) => {
  return http.get(`${apiUrl}/confmetaprtable/${academicYear}`);
};

export const createMetaPrTable = (metaPrTable) => {
  const data = metaPrTable.map((x) => ({
    metaPrItems: x.metaPrItems.map((x) => ({ ...x, gradeId: x.gradeId.id })),
    monthIndex: x.monthIndex,
    monthName: x.monthName,
  }));

  return http.post(`${apiUrl}/create`, data);
};

export const editMetaPrTable = (metaPrTable) => {
  const changedRecords = metaPrTable
    .filter((x) => x.metaPrItems.find((x) => x.hasChanged))
    .map((x) => x.metaPrItems.find((x) => x.hasChanged));

  if (changedRecords.length > 0) {
    const data = changedRecords.map((x) => ({
      ...x,
      gradeId: x.gradeId.id,
    }));

    return http.post(`${apiUrl}/edit`, data);
  }
};

export const existPeiForAcademicYear = (academicYearId) => {
  return http.get(`api/pei/existpeiforacademicyear/${academicYearId}`);
};
